<div class="snackbar-content">
    <div class="snackbar-message">
      <strong class="title">{{ data.title }}</strong>
      <p class="message">{{ data.message }}</p>
    </div>
    <div class="snackbar-actions">
        <button mat-button (click)="onclose()" style="color: #fff;">Close</button>
      <button *ngIf="data.onRefresh" mat-button style="color: #FFC107;" (click)="onRefresh()">Show</button>
    </div>
  </div>
  